import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { EventsProvider } from '../../providers/events/events';
import moment from 'moment';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { AppState } from '../../config/state';
import { Platform, NavController, ModalController, PopoverController, LoadingController } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { CoLocationComponent } from '../co-location/co-location';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
import { CoListComponent } from '../co-list/co-list';
import { Events } from 'ionic-angular';
import { AttendPage } from '../../pages/attend/attend';
import { CoEventsFeaturedCardComponent } from '../co-events-featured-card/co-events-featured-card';
import { SocialMediaSharingProvider } from '../../providers/social-media-sharing/social-media-sharing';
import { SoundsProvider } from '../../providers/sounds/sounds';

@Component({
  selector: 'co-events-explore-desktop',
  templateUrl: 'co-events-explore-desktop.html'
})
export class CoEventsExploreDesktopComponent {

  text: string;
  allEvents: any;
  searchTypes: any;
  pageEventLanes: any;
  clientKeyword: any;
  viewType: any = this.state.mode
  screenWidth: any;
  aboveWidthBreakpoint: boolean;
  isApp: boolean = this.state.mode != 'desktop';
  featuredArray: any = [];
  whichScreenToGoTo: string = 'week';
  featuredEvent: any;
  isSharedScreen: boolean;
  @Output() viewMoreEventsOfType = new EventEmitter<any>();
  @ViewChild(CoEventsFeaturedCardComponent) featuredCardComp: CoEventsFeaturedCardComponent;
  constructor(public eventsProvider: EventsProvider, private clientDetails: ClientDetailsProvider, public state: AppState, public platform: Platform, public config: ConfigProvider, public navCtrl: NavController, public modalCtrl: ModalController, public popoverCtrl: PopoverController, private events: Events, private socialShare: SocialMediaSharingProvider, private loading: LoadingController, private sounds : SoundsProvider) {
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.screenWidth = self.platform.width();
      self.viewType != 'desktop' ? self.isApp = true : self.isApp = false;
      self.platform.width() > 992 ? self.aboveWidthBreakpoint = true : self.aboveWidthBreakpoint = false;
    });
    this.isSharedScreen = this.state.sharedScreen;
  }

  ngOnInit() {
    this.events.subscribe('updateAllEvents', async () => {
      if(this.allEvents)this.allEvents = await this.eventsProvider.checkInterestedEvents(this.allEvents);
      if(this.featuredArray)this.featuredArray = await this.eventsProvider.checkInterestedEvents(this.featuredArray);
    });
    this.events.subscribe('registeredEvent', (event) => {
      if(this.allEvents){
        this.allEvents.forEach(element => {
          if (element.eventId === event.eventId) element = event;
        });
      }
    });

    const appRootIos = document.querySelector('.app-root-ios');
    if (appRootIos) {
      for(let x=0; x<20; x++){
        setTimeout(() => {
          appRootIos['style']['zIndex'] = appRootIos['style']['zIndex'] === '1' ? '2' : '1';
        }, x * 500);
      }
    }
    // this.getExploreEvents();
  }
  ngOnDestroy(){
    this.events.unsubscribe('updateAllEvents');
    this.events.unsubscribe('registeredEvent');
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }
  getExploreEvents(allBranches?) {
    let loader = this.loading.create({ content: "Retrieving events..." });
    loader.present();
    let queries = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    if(allBranches){
      queries = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
    } else if(this.state.branchInformation && this.state.branchInformation.id){
      // queries = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}"`;
      queries = `startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}", locationId: ${this.state.branchInformation.id}`;
    }
    this.eventsProvider.getEvents(queries).then((info) => {
      this.allEvents = info.allEvents;

      this.searchTypes = info.searchTypes;
      // console.log(this.searchTypes)
      let returnObj = {};
      returnObj = this.allEvents.reduce((red, event) => {
        if (!event.types) return red;
        event.types.forEach(type => {
          if (!red[type]) red[type] = [type];
          red[type].push(event);
        });
        return red;
      }, {});
      let featuredObj = [];
      featuredObj = this.allEvents.forEach((event) => {
        if (event.branchFeatured || event.globalFeatured) {
          this.featuredArray.push(event)
        }
      });

      if (this.featuredArray.length > 0) {
        // console.log(this.featuredArray);
        let randomNum = Math.floor(Math.random() * (this.featuredArray.length));
        this.featuredEvent = this.featuredArray[randomNum];
        // console.log(this.featuredEvent, randomNum);
        this.featuredCardComp.getExploreEvents(this.featuredEvent);
      }

      this.pageEventLanes = Object.keys(returnObj).map((key) => {
        return returnObj[key]
      });
      // console.log(this.pageEventLanes);
      this.pageEventLanes.sort((a,b)=>{
        return a[0].localeCompare(b[0], undefined, {numeric: true, sensitivity: 'base'})
      })
      loader.dismiss().catch(err=>{});
    });
  };

  getEventColor(eventType) {
    try {
      let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
      return eventTypeObject.color;
    } catch (ex) {
      return "lightblue";
    };
  };

  goToMoreEventsOfType(eventType) {
    // this.config.load(this.state.appId).then(cfg => {
    //   this.navCtrl.push(AttendPage, { filterType: 'eventType', eventType: eventType, filter: { tracker: true, eventType: [`${eventType}`], date: {lower: moment().startOf('day'), upper: moment().add(10, 'days').endOf('day')}  }, eventView: 'day' });
    // });
    this.events.publish('sendMoreEventsFromExplore',{ tracker: true, eventType: [`${eventType}`], date: {lower: moment().startOf('day'), upper: moment().add(10, 'days').endOf('day')}});
  }

  goToMoreFeaturedEvents() {
    console.log('there are no featured events currently');
  }

  getEventImage(eventType) {
    try {
      let eventTypeObject = this.searchTypes.find(object => object.name === eventType);
      return eventTypeObject.image;
    } catch (ex) {
      return "";
    }
  }

  goToEventDetails(eventId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId });
    });
  }

  goToLocation(locationId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoLocationComponent, { location: locationId });
    });
  }

  openInterestedPopover(button, event) {
    let self = this;
    this.eventsProvider.openInterestedPopover(button, event, self);
  }

  goToList() {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoListComponent, { clientKeyword: this.clientKeyword, listType: 'events' });
    });
  }

  shareEvent(button, event) {
    if (this.viewType === 'app') {
      this.socialShare.shareOptions(event);
    } else if (this.viewType === 'desktop') {
      this.eventsProvider.openSocialMediaPopover(button, event);
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/co-events-explore-desktop/co-events-explore-desktop.ts